//Property separators
export const SEPARATOR_PVA = "::";
export const SEPARATOR_SUBPROP = ".";
